var map = {
	"./Addempl-2x.png": 1106,
	"./Addempl.png": 1107,
	"./chargebee-icon.svg": 153,
	"./comodo-secure-seal.png": 1108,
	"./day-2x.png": 1109,
	"./day.png": 1110,
	"./favicon.candidate.ico": 1111,
	"./favicon.development.ico": 1112,
	"./favicon.ico": 1113,
	"./favicon.production.ico": 1114,
	"./favicon.staging.ico": 1115,
	"./icon-clock-in.png": 1116,
	"./icon-clock-out.png": 1117,
	"./large_panda.jpg": 1118,
	"./lhdn.gif": 1119,
	"./logo-xero.svg": 1120,
	"./panda_jump.png": 1121,
	"./payrollpanda-logo-lg.png": 1122,
	"./payrollpanda-logo-md.png": 1123,
	"./payrollpanda-logo-sm.png": 1124,
	"./payrollpanda-logo.png": 1125,
	"./processed-2x.png": 1126,
	"./processed.png": 1127,
	"./quickbooks.png": 1128,
	"./refer-icon.png": 1129,
	"./signup-panda-2x.png": 1130,
	"./signup-panda.png": 1131,
	"./start-2x.png": 1132,
	"./start.png": 1133,
	"./xero.png": 1134
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1105;



// WEBPACK FOOTER //
// ./images nonrecursive /^/.//